export const CURRENCY = {
  CUP: 'CUP',
  USD: 'USD',
  EUR: 'EUR',
  MLC: 'MLC',

}
